import { NgModule } from "@angular/core";
import { PrimeNgModule } from "@primeng";
import { GridModule } from "@features/grid";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { ReportingCoreModule } from "../reporting-core.module";
import { QueryTableSelectorComponent } from "./components/query-table-selector.component";


@NgModule({
    declarations: [
        QueryTableSelectorComponent
    ],
    exports: [
        QueryTableSelectorComponent
    ],
    imports: [
        GridModule,
        PrimeNgModule,
        BbwtSharedModule,
        ReportingCoreModule
    ]
})
export class QueryTableSelectorModule {
}